import type { StateEditFieldProps } from "./state-edit-field.type";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { FieldSelectTag } from "@/ui/field-select-tag";

import { useGetStateEditFieldOptions } from "./state-edit-field.hook";

import "./state-edit-field.style.less";

export const StateEditField = ({
  type,
  model,
  label,
  ...fieldProps
}: StateEditFieldProps) => {
  const { t } = useTranslation();
  const options = useGetStateEditFieldOptions(type, model);

  return (
    <FieldSelectTag
      {...fieldProps}
      label={label}
      options={options}
      aria-label={label ?? t("global:state")}
      dropdownClassName={classNames("state-edit-field-dropdown", `-${type}`)}
    />
  );
};
